import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useRef } from 'react';
import { usePopper } from 'react-popper';
import { styled } from '../../styles';
import { keyframes } from '@emotion/react';
const delayVisibility = keyframes `
    0% {
        opacity: 0;
    }
    99% {
        opacity: 0;
    }
    100% {
        opcaity: 1;
    }
`;
export const Tooltip = ({ children, message, showTooltip, delay, offsetValue = 0, distance = 10, color = 'white', placement = 'bottom', fallbackPlacements = ['top', 'bottom', 'left', 'right'], arrowSize = '10px', borderRadius = '4px', opacity = '1', padding = '8px', width, height, maxWidth, minWidth, dataTestId, isModal = false, position, inset, transform, }) => {
    const wrapperRef = useRef(null);
    const tooltipRef = useRef(null);
    // the ref for the arrow must be a callback ref
    const [arrowRef, setArrowRef] = useState(null);
    const { styles, attributes } = usePopper(wrapperRef.current, tooltipRef.current, {
        placement,
        modifiers: [
            {
                name: 'arrow',
                options: {
                    element: arrowRef,
                },
            },
            {
                name: 'offset',
                options: {
                    offset: [offsetValue, distance],
                },
            },
            {
                name: 'flip',
                options: {
                    fallbackPlacements,
                },
            },
        ],
    });
    const containerStyles = {
        ...styles.popper,
        width,
        height,
        zIndex: 2,
        maxWidth,
        minWidth,
        ...(position && { position }),
        ...(inset && { inset }),
        ...(transform && { transform }),
    };
    return (_jsxs(Wrapper, { ref: wrapperRef, children: [children, showTooltip ? (_jsxs(TooltipContainer, { delay: delay, ref: tooltipRef, style: containerStyles, ...attributes.popper, color: color, arrowSize: arrowSize, borderRadius: borderRadius, opacity: opacity, padding: padding, "data-testid": dataTestId, isModal: isModal, children: [_jsx("div", { ref: setArrowRef, style: styles.arrow, className: "arrow" }), message] })) : null] }));
};
const Wrapper = styled.div(() => {
    return {
        display: 'inline-block',
    };
});
const TooltipContainer = styled.div `
    display: flex;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    background-color: ${props => props.isModal ? `rgba( 55, 53, 57, ${props.opacity})` : props.theme.colors[props.color]};
    padding: ${props => props.padding};
    opacity: ${props => (props.isModal ? '1' : props.opacity)}
    color: ${props => props.theme.colors.grey90};
    border-radius: ${props => props.borderRadius};
    animation: ${delayVisibility} ${props => props.delay}ms linear;
    animation-fill-mode: forwards;
    .arrow {
        width: 0px;
        height: 0px;
        z-index: -1;
        &:before {
            position: absolute;
            content: '';
            width: ${props => props.arrowSize};
            height: ${props => props.arrowSize};
            background-color: ${props => props.theme.colors[props.color]};
            transform: translate(-50%, -50%) rotate(45deg);
        }
    }
    &[data-popper-placement^='bottom'] > .arrow {
        top: 0;
        left: 50%;
        &:before {
            box-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
        }
    }
    &[data-popper-placement^='top'] > .arrow {
        bottom: 0;
        left: 50%;
        &:before {
            box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
        }
    }
    &[data-popper-placement^='right'] > .arrow {
        top: 50%;
        left: 0;
        &:before {
            box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.1);
        }
    }
    &[data-popper-placement^='left'] > .arrow {
        top: 50%;
        right: 0;
        &:before {
            box-shadow: 1px -1px 1px rgba(0, 0, 0, 0.1);
        }
    }
`;
//# sourceMappingURL=tooltip.js.map